<template>
    <b-container class="container-panel">
        <div class="row">
            <div class="col-sm-6">
                <h3>Customer Protection Activity</h3>
            </div>
            <div class="col-sm-6 text-right">
                <span>Customer A#: {{this.$route.params.aNumber}}</span>
                <br />
                <span>Customer Name: {{accountName}}</span>
            </div>
            <div class="col-sm-12"></div>
        </div>
        <div class="row" v-if="hasAddPermission" id="protectButtonRow">
            <div class="centered-div vert-pad">
                <b-button v-on:click="toggleInsertProtection" variant="primary">Protect</b-button>
            </div>
        </div>
        <b-alert v-model="showSuccess" variant="success" dismissible>
            {{successMessage}}
        </b-alert>
        <div v-if="isClosing">
            <legend>Remove Customer From Protection</legend>
            <b-form-textarea id="closeNotes"
                             v-model="closeNotes"
                             placeholder="Enter protection closing notes here."
                             rows="3"
                             max-rows="6"></b-form-textarea>

            <div id="closeProtectionValidation" class="col-sm-12 text-center text-danger" style="display: inline;">
                <ul v-for="error in closeErrors" :key="error">
                    <li>{{ error }}</li>
                </ul>
            </div>
            <div class="row vert-pad">
                <b-button class="centered-div" v-on:click="submitCloseProtectionForm" :disabled="!hasClosePermission" variant="success">- Remove From Protection</b-button>
                <b-button class="centered-div" v-on:click="clearCloseProtectionForm" variant="outline-primary">Close - Do Not Remove From Protection</b-button>
            </div>
        </div>
        <div v-if="isAdding">
            <legend>Add Customer To Protection</legend>
            <div>
                <label for="protectionReasonsDropdown">Protection Reason</label>
                <b-form-select v-model="selectedReasonId" :options="reasonOptions"></b-form-select>

                <br />
                <label for="expiration-date">Expiration Date</label>
                <b-form-datepicker id="expiration-date" :min="today" v-model="insertExpirationDate" class="mb-2"></b-form-datepicker>

                <b-form-textarea id="insertNotes"
                                 v-model="insertNotes"
                                 placeholder="Enter protection notes here."
                                 rows="3"
                                 max-rows="6"></b-form-textarea>

                <div id="insertProtectionValidation" class="col-sm-12 text-center text-danger" style="display: inline;">
                    <ul v-for="error in insertErrors" :key="error">
                        <li>{{ error }}</li>
                    </ul>
                </div>
            </div>
            <div class="row vert-pad">
                <b-button class="centered-div" v-on:click="submitInsertProtectionForm" variant="success">+ Submit</b-button>
                <b-button class="centered-div" v-on:click="clearInsertProtectionForm" variant="outline-primary">Clear</b-button>
            </div>
        </div>
        <div class="row">
            <b-table striped hover :fields="protectionFields" :items="protectionEntries">

                <template #cell(notes)="data">
                    <b-button v-bind:id="`notes-button-${data.item.protectNbr}`" href="#" tabindex="0">
                        <b-icon icon="info-circle" aria-hidden="true"></b-icon>
                    </b-button>

                    <b-popover placement="left" :target="`notes-button-${data.item.protectNbr}`" title="Notes" triggers="focus">
                        {{ data.item.notes }}
                    </b-popover>

                </template>

                <template #cell(closeNotes)="data">
                    <b-button v-bind:id="`closeNotes-button-${data.item.protectNbr}`" href="#" tabindex="0">
                        <b-icon icon="info-circle-fill" aria-hidden="true"></b-icon>
                    </b-button>

                    <b-popover placement="right" :target="`closeNotes-button-${data.item.protectNbr}`" title="Close Notes" triggers="focus">
                        {{ data.item.closeNotes }}
                    </b-popover>
                </template>

                <template #cell(closeButton)="data">
                    <b-button v-bind:id="`closeProtection-button-${data.item.protectNbr}`" href="#" tabindex="0" v-on:click="toggleCloseProtection(data.item.protectNbr)" :disabled="!hasClosePermission">
                        <b-icon icon="x-octagon" aria-hidden="true"></b-icon>
                    </b-button>
                </template>

            </b-table>
        </div>
    </b-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Repo from '../repo';
    import i18n from '../localization';

    export default {
        name: "CustomerProtection",
        data: () => ({
            protectionEntries: [],
            protectionFields: [
                {
                    key: 'reasonDesc',
                    label: 'Protect Reason'
                },
                {
                    key: 'protectFromDesc',
                    label: 'Protect From'
                },
                {
                    key: 'statusDescription',
                    label: 'Status',
                },
                { key: 'startDate', label: 'Start Date' },
                { key: 'expirationDate', label: 'Expiration Date' },
                { key: 'esTransactionId', label: 'Trans ID' },
                'notes',
                'closeNotes',
                { key: 'appliedBy', label: 'Entered By' },
                { key: 'endedBy', label: 'Closed By' },
                { key: 'closeButton', label: 'Close' },
                ],
            accountName: "",
            permissions: [],
            protectionReasons: [],
            reasonOptions: {},
            updatingUserId: "",
            isClosing: false,
            selectedCloseProtectionId: -1,
            closeNotes: "",
            closeErrors: [],
            isAdding: false,
            selectedReasonId: 7,
            insertExpirationDate: null,
            insertNotes: "",
            insertErrors: [],
            showSuccess: false,
            successMessage: '',
            hasAddPermission: false,
            hasClosePermission: false
        }),
        mounted() {

            this.$store.dispatch('shell/updateLanguageFromQuery', this.$route.query.lang);
            Repo.AuthenticationService.ValidateToken({ Token: this.$route.params.authToken }).then(res => {
                if (res && res.success) {
                    this.updatingUserId = res.userId;
                    this.getCustomerName();
                    this.getCustomerProtectionActivity().then(res => {
                        this.protectionEntries = res;
                    });
                    this.getCustomerPermissions();
                    this.getProtectionReasons();
                }
                else {
                    this.$store.dispatch('shell/addErrorMessages', i18n.t('NOT_AUTHENTICATED'));
                }
                this.showHeader = true;
            })
        },
        methods:
        {
            getCustomerName: async function () {
                var req = { ANumber: this.$route.params.aNumber, CustomerNumber: this.$route.params.customerNumber };
                return await Repo.QuickPayService.GetCustomerName(req).then(res => {
                    if (res.isValid) 
                    {
                        this.accountName = res.firstName + " " + res.lastName
                        return res;
                    } 
                    else 
                    {
                        return {};
                    }
                });
            },
            getCustomerProtectionActivity: async function (request) {
                let req = { CustomerNumber: this.$route.params.customerNumber, DpiNumber: this.$route.params.aNumber, Token: this.$route.params.authToken }
                let res = await Repo.CustomerProtectionService.GetCustomerProtectionActivity(req);
                return res.result; 
            },
            getCustomerPermissions: async function ()
            {
                let res = await Repo.PermissionsService.GetPermissionsObjects({ token: this.$route.params.authToken });
                this.permissions = res;
                if (this.permissions !== null && this.permissions.filter(x => x === 5216).length > 0) {
                    this.hasClosePermission = true
                }
                return res;
            },
            getProtectionReasons: async function ()
            {
                let req = { CustomerNumber: this.$route.params.customerNumber, DpiNumber: this.$route.params.aNumber, Token: this.$route.params.authToken };
                let res = await Repo.CustomerProtectionService.GetProtectionReasons(req);
                this.protectionReasons = res.result;
                if (this.protectionReasons.length > 0) {
                    this.selectedReasonId = this.protectionReasons[0].protectReasonId
                    this.hasAddPermission = true
                } 
                this.reasonOptions = res.result.map(obj => ({ 'value': obj.protectReasonId, 'text': obj.reasonDesc }))
                return res.result;
            },
            validateInsertForm: function ()
            {
                this.insertErrors = [];
                if (this.selectedReasonId == null)
                {
                    this.insertErrors.push("Must select a protection reason.")
                }
                if (this.insertExpirationDate == null)
                {
                    this.insertErrors.push("Must select an expiration date.")
                }
                if (this.insertNotes == "") {
                    this.insertErrors.push("Protections must include notes.")
                }
                else if (this.insertNotes.length < 10 ) {
                    this.insertErrors.push("Notes must be at least 10 characters.")
                }
            },
            submitInsertProtectionForm: async function ()
            {
                this.validateInsertForm();

                if (this.selectedReasonId !== null
                    && this.insertExpirationDate !== null
                    && this.insertNotes != ""
                    && this.insertNotes.length >= 10)
                {
                    let req =
                    {
                        'CustomerNumber': this.$route.params.customerNumber,
                        'ProtectionReasonId': this.selectedReasonId,
                        'ESTransactionId': "", // Left blank in Ambit.Web.Finance, doing so here
                        'Notes': this.insertNotes,
                        'UpdatingUserId': this.updatingUserId, 
                        'AppUpdate': "PaymentLobby",
                        'ExpirationDate': this.insertExpirationDate,
                        'Token': this.$route.params.authToken,
                    }
                    let res = await Repo.CustomerProtectionService.InsertCustomerProtectionActivity(req);
                    if (res.success === true)
                    {
                        this.clearInsertProtectionForm();
                        this.showSuccess = true;
                        this.successMessage = "Successfully inserted a protection!";
                        this.forceRerender();
                    }

                    return res;
                }
                return null;
            },
            validateCloseForm: function () {
                this.closeErrors = [];
                if (this.selectedCloseProtectionId == -1) {
                    this.closeErrors.push("Must select a protection reason - please reselect the protection you wish to close.")
                }
                if (this.closeNotes == "") {
                    this.closeErrors.push("Protections must include notes.")
                }
                else if (this.closeNotes.length < 10) {
                    this.closeErrors.push("Notes must be at least 10 characters.")
                }
            },
            submitCloseProtectionForm: async function ()
            {
                this.validateCloseForm();

                if (this.selectedCloseProtectionId != -1
                    && this.closeNotes != ""
                    && this.closeNotes.length >= 10)
                {
                    let req = {
                        'CustomerNumber': parseInt(this.$route.params.customerNumber),
                        'UserUpdate': this.updatingUserId,
                        'Token': this.$route.params.authToken,
                        'ProtectionID': parseInt(this.selectedCloseProtectionId),
                        'Notes': this.closeNotes,
                    };

                    let res = await Repo.CustomerProtectionService.CloseProtection(req);
                    if (res.error == null) {
                        this.clearCloseProtectionForm();
                        this.showSuccess = true;
                        this.successMessage = "Successfully closed a protection!";
                        this.forceRerender();
                    }
                    return res;
                }
                return null;
            },
            clearInsertProtectionForm: function () {
                this.insertExpirationDate = null;
                this.insertNotes = "";
                this.selectedReasonId = 7; // general protection, resetting to default
                this.insertErrors = [];
                this.isAdding = false;
            },
            clearCloseProtectionForm: function () {
                this.closeNotes = "";
                this.selectedCloseProtectionId = -1;
                this.closeErrors = [];
                this.isClosing = false;
            },
            toggleInsertProtection: function () {
                this.isAdding = true;
                this.isClosing = false;
            },
            toggleCloseProtection: function (protId) {
                this.selectedCloseProtectionId = protId;
                this.isAdding = false;
                this.isClosing = true;
            },
            forceRerender() {
                this.getCustomerProtectionActivity().then(res => {
                    this.protectionEntries = res;
                });
            }
        },
        computed: {
            today: function () {
                return new Date()
            }
        }
    }
</script>
<style>
    .disabled-protection-btn {
        display: none !important;
    }
    .centered-div {
        margin-left: auto;
        margin-right: auto;
    }
    .vert-pad {
        margin-bottom: 15px;
        margin-top: 5px;
    }
</style>